export default __webpack_public_path__ + "assets/images/icon-delete2.9a6c8b4d7698a62101a91bf726afae92.svg";